module.exports = __webpack_public_path__ + "static/img/spremidos-uva.bfd28dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/spremidos-uva.png
// module id = 1qK5
// module chunks = 0